import { ChatBotHeaderProps } from '../../../types/chatbot'
import Stars from '../../../assets/stars.svg'
import StarsTransparent from '../../../assets/stars_trans.svg'
import styles from '../styles/chatbot.module.scss'
import X from '../../../assets/X.svg'

const ChatBotHeader = ({
  expanded,
  closeChatBot,
  openChatBot
}: ChatBotHeaderProps) => {
  return (
    <>
      {expanded ? (
        <div className={styles['chatbot-header']}>
          <div className={styles['chatbot-icon']}>
            <img src={StarsTransparent} alt='Stars' />
            [SensAI]
          </div>
          <div className={styles['chatbot-header-controls']}>
            <div
              className={styles['close-button']}
              onClick={closeChatBot}
              data-testid='closeButton'
            >
              <div className={styles['close-icon']}>
                <img src={X} alt='close' />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div
          onClick={openChatBot}
          className={styles['chatbot-widget']}
          data-testid='openButton'
        >
          <div className={styles['chatbot-icon']}>?</div>
          <div className={styles.stars}>
            <img src={Stars} alt='Stars' className={styles['stars-icon']} />
          </div>
        </div>
      )}
    </>
  )
}

export default ChatBotHeader
